import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const purchases = [{
  name: 'Giulia R.',
  city: 'Milano',
  time: '2 minuti fa'
}, {
  name: 'Francesca B.',
  city: 'Roma',
  time: '8 minuti fa'
}, {
  name: 'Chiara M.',
  city: 'Torino',
  time: '5 minuti fa'
}, {
  name: 'Alessia M.',
  city: 'Napoli',
  time: '11 minuti fa'
}, {
  name: 'Sara L.',
  city: 'Bologna',
  time: '4 minuti fa'
}, {
  name: 'Valentina C.',
  city: 'Firenze',
  time: '7 minuti fa'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseIndex, setPurchaseIndex] = useState(0);
  useEffect(() => {
    const showTimer = window.setTimeout(() => setIsVisible(true), 4000);
    const rotationTimer = window.setInterval(() => {
      setPurchaseIndex(current => (current + 1) % purchases.length);
    }, 8000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearInterval(rotationTimer);
    };
  }, []);
  const purchase = purchases[purchaseIndex];
  return <AnimatePresence data-id="element-141">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} className="fixed bottom-20 left-4 z-30 flex max-w-[calc(100%-2rem)] items-start gap-3 rounded-2xl border border-brand-creamDark bg-white p-4 pr-10 shadow-xl sm:bottom-6 sm:left-6 sm:max-w-sm" data-id="element-142">
          <button onClick={() => setIsVisible(false)} className="absolute right-3 top-3 text-brand-gray hover:text-brand-text" aria-label="Chiudi notifica" data-id="element-143">
            <X className="h-4 w-4" data-id="element-144" />
          </button>
          <div className="mt-0.5 text-2xl" data-id="element-145">🧘‍♀️</div>
          <div data-id="element-146">
            <p className="text-sm font-bold text-brand-text" data-id="element-147">
              {purchase.name} · {purchase.city} 🇮🇹
            </p>
            <p className="mb-1 text-xs font-bold text-brand-green" data-id="element-148">
              Ha acquistato YOGA PRONTA
            </p>
            <p className="flex items-center gap-1 text-[10px] text-brand-gray" data-id="element-149">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-green-500" data-id="element-150" />
              Acquisto verificato · {purchase.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}